
    const data = {"name":"src/core/icons/calendar-plus-outline","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M13 13h3v2h-3v3h-2v-3H8v-2h3v-3h2v3m8-8v14c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h1V1h2v2h8V1h2v2h1a2 2 0 0 1 2 2M5 5v2h14V5H5m14 14V9H5v10h14Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            